import { EXPENSE_TYPES } from '@constants/ssap/hhmTypes/incomeAndExpenceTypes';

/**
 * @param {Array} expenses single household member's `expenses` array
 * @returns {boolean} true when the member has at least one student loan interest deduction
 */
export const hasStudentLoanInterestExpense = (expenses = []) =>
    expenses.some(expense => expense.type === EXPENSE_TYPES.STUDENT_LOAN_INTEREST);

/**
 * @param {Array} householdMembers `taxHousehold.householdMember` array
 * @returns {boolean} true when any member in the household has a student loan interest deduction
 */
export const hasHouseholdStudentLoanInterestExpense = (householdMembers = []) =>
    householdMembers.some(hhm => hasStudentLoanInterestExpense(hhm.expenses));
